import { createContext, useContext } from "react";

import type { MarketingCampaignFormModel } from "../../../model";

type QueryData = MarketingCampaignFormModel["QueryData"];
type ViewModel = MarketingCampaignFormModel["ViewModel"];

export type MarketingCampaignFormModelContextType = {
	viewModel: ViewModel;
	onSetViewModel: <K extends keyof ViewModel>(values: { key: K; value: ViewModel[K] }[]) => void;

	queryData: QueryData;
};

export const MarketingCampaignFormModelContext = createContext<MarketingCampaignFormModelContextType | null>(null);

export const useMarketingCampaignFormModelContext = () => {
	const context = useContext(MarketingCampaignFormModelContext);

	if (!context) {
		throw new Error(
			"useMarketingCampaignFormModelContext must be used within a MarketingCampaignFormModelContext.Provider",
		);
	}

	return context;
};
